import { BaseService } from "mrb/core";
import LoadioContentProfileApiRouteService from "./LoadioContentProfileApiRouteService";

class LoadioContentProfileService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new LoadioContentProfileApiRouteService());
    }

    find(filter, abortSignal = null) {
        const url = this.routeService.find(filter);
        return this.apiClient.get(url, null, abortSignal);
    }

    get(id, options = {}, abortSignal = null) {
        const url = this.routeService.get(id, options);
        return this.apiClient.get(url, null, abortSignal);
    }

    getDeviceCount(id, abortSignal = null) {
        const url = this.routeService.getDeviceCount(id);
        return this.apiClient.get(url, null, abortSignal);
    }

    create(resource, abortSignal = null) {
        const url = this.routeService.create(resource);
        return this.apiClient.post(url, resource, null, abortSignal);
    }

    update(resource, abortSignal = null) {
        const url = this.routeService.update(resource);
        return this.apiClient.put(url, resource, null, abortSignal);
    }

    delete(resource, abortSignal = null) {
        const url = this.routeService.delete(resource);
        return this.apiClient.delete(url, null, abortSignal);
    }

    assignArtists(id, artistIds, abortSignal = null) {
        const url = this.routeService.assignArtists(id);
        return this.apiClient.put(url, { artistIds }, null, abortSignal);
    }

    unassignArtists(id, artistIds, abortSignal = null) {
        const url = this.routeService.unassignArtists(id);
        return this.apiClient.delete(url, null, { artistIds }, abortSignal);
    }

    enableAllArtists(id, genreId = null, searchQuery = null, abortSignal = null) {
        const url = this.routeService.enableAllArtists(id, genreId, searchQuery);
        return this.apiClient.put(url, null, null, abortSignal);
    }

    disableAllArtists(id, genreId = null, searchQuery = null, abortSignal = null) {
        const url = this.routeService.disableAllArtists(id, genreId, searchQuery);
        return this.apiClient.delete(url, null, null, abortSignal);
    }
}

export default LoadioContentProfileService;
